export const ssItems = {
  FILTERS: 'filters',
};

export const clearFilters = () => sessionStorage.removeItem(ssItems.FILTERS);

export const clearSessionData = () => sessionStorage.clear();

/**
 * Session-storage layout for persisted per-account, per-table
 * filter / sort state is keyed by a 32-bit hash of the account
 * uuid, NOT the raw uuid — the algorithm mirrors `hashCode` in
 * `@shared/hooks/useFetchList` (a Java-style rolling sum of char
 * codes). Any wipe helper that wants to invalidate a live
 * `useFetchList` cache has to hash first, otherwise it edits a
 * bucket the hook will never read.
 */
const hashCode = (str) => {
  let hash = 0;
  if (!str || str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
};

/**
 * Wipe the persisted filter/sort entries for one or more table
 * keys inside a single account. Used when we need `useFetchList`
 * to fall back to the caller's `baseFilter` on next mount — e.g.
 * the Sidebar's Alerts drop-down pushes a fresh pre-filter that
 * would otherwise be shadowed by whatever the user last picked
 * on that page.
 */
export const clearTableFilters = (currentAccountUuid, tableKeys) => {
  if (!currentAccountUuid || !tableKeys?.length) return;
  const raw = sessionStorage.getItem(ssItems.FILTERS);
  if (!raw) return;
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    sessionStorage.removeItem(ssItems.FILTERS);
    return;
  }
  const bucketKey = hashCode(currentAccountUuid);
  const accountBucket = parsed?.[bucketKey];
  if (!accountBucket) return;
  tableKeys.forEach((key) => {
    delete accountBucket[key];
  });
  sessionStorage.setItem(ssItems.FILTERS, JSON.stringify(parsed));
};
